<template>
  <v-dialog
    v-model="isOpen"
    persistent
    max-width="500"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
        flat
      >
        <v-toolbar-title class="white--text">
          アカウントロック解除
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4 text-center">
        アカウントロックを解除しますがよろしいですか？
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          color="grey"
          text
          @click="cancel"
        >
          CANCEL
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="confirm"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UnlockDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
      this.isOpen = false
    },
    cancel() {
      this.$emit('cancel')
      this.isOpen = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
